import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles<void, 'option' | 'selectedOption'>()((theme, _, classes) => ({
	option: {
		cursor: 'pointer',
		padding: theme.spacing.small,
		display: 'flex',
		gap: theme.spacing.xsmall,
		alignItems: 'center',
		justifyContent: 'space-between',
		border: theme.flightSelection.border.default,
		background: '#fff',
		textAlign: 'left',

		'&&:first-of-type': {
			borderTopLeftRadius: theme.borderRadius.rounded,
			borderTopRightRadius: theme.borderRadius.rounded,
		},

		'&&:last-of-type': {
			borderBottomRightRadius: theme.borderRadius.rounded,
			borderBottomLeftRadius: theme.borderRadius.rounded,
		},

		[`+ .${classes.option}:not(.${classes.selectedOption})`]: {
			borderTop: 0,
		},

		[`&&:has( + .${classes.selectedOption})`]: {
			borderBottom: 0,
		},
	},
	selectedOption: {
		border: theme.flightSelection.border.selected,
		padding: `calc(${theme.spacing.small} - ${theme.border.thin})`,
	},
	disabledOption: {
		cursor: 'default',
	},
}));
